import React from 'react';
import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS from '../../events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import DeltaMetric from '../DeltaMetric';

export default function TotalAssociatedWithEvent(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const allSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'events',
            $where: {
              $and: REQUIRED_FIELDS.$and,
              // 'creator.isEducator': true,
              networkId: network?.id
            }
          }
        ],
        $where: {
          createdAt: {
            $lte: schoolEnd
          }
        },
        $having: {
          numberOfEvents: {
            $gte: 1
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const newSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfEvents',
            relation: 'events',
            $where: {
              $and: REQUIRED_FIELDS.$and,
              // 'creator.isEducator': true,
              networkId: network?.id
            }
          }
        ],
        $where: {
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        },
        $having: {
          numberOfEvents: {
            $gte: 1
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    allSchools.state === PayloadStates.FETCHING ||
    newSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Total engaged with Event"
      />
    );
  }

  return (
    <DeltaMetric
      name="Total engaged with Event"
      value={allSchools.meta.totalCount}
      delta={newSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
